var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle105(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "248.05919608340943 255.05923298529984 28.671057885390468 28.91423881549656",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M252.06,269.56c-.07-5.76,4.44-10.43,10.15-10.5,5.87-.07,10.56,4.66,10.52,10.62-.04,5.67-4.32,10.14-9.87,10.29-5.82.15-10.73-4.58-10.8-10.42Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle105);
export default __webpack_public_path__ + "static/media/twinkle-1-05.7f57a45837cd921b1f0e8201463fb063.svg";
export { ForwardRef as ReactComponent };